module.exports = __webpack_public_path__ + "84a27571ae0cdac7d6b57c5b7861c77c.svg";